import styled from 'styled-components'

import { Skeleton, fromMd } from '@syconium/little-miss-figgy'

export const Body = styled.main``

export const Hero = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: 18px 0 34px;

  ${fromMd} {
    padding: 73px 0;
  }
`

export const HeroTitle = styled(Skeleton)`
  height: 32px;
  width: 228px;

  ${fromMd} {
    height: 54px;
    width: 455px;
  }
`

export const HeroSubtitle = styled(Skeleton)`
  height: 16px;
  margin-top: 16px;
  width: 276px;

  ${fromMd} {
    height: 22px;
    width: 325px;
  }
`
